var html = document.documentElement;
var body = document.body;

slider();
toggleItem();
megaMenu();
mobileMenu();

function slider() {
  const slider = document.querySelector('.slider');

  if (slider && slider.children.length > 1) {
    new Flickity('.slider', {
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      adaptiveHeight: true
    });
  } 
}

function toggleItem() {
  document.addEventListener('DOMContentLoaded', function() {
    var toggleElements = document.querySelectorAll('.toggle');
  
    toggleElements.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        var content = toggle.nextElementSibling;
        var plusIcon = toggle.querySelector('.plus');
        var minusIcon = toggle.querySelector('.minus');
  
        content.classList.toggle('hidden');
        plusIcon.classList.toggle('hidden');
        minusIcon.classList.toggle('hidden');
      });
    });
  });  
}

function megaMenu() {
  const menuTriggers = document.querySelectorAll('.menu-item');

  menuTriggers.forEach((item) => {
    const menuTrigger = item.querySelector('.menu-item-link')
    const megaMenu = item.querySelector('.mega-menu')

    if (megaMenu) {
      let isMenuVisible = false

      menuTrigger.addEventListener('mouseover', function() {
        console.log('ek')
        megaMenu.classList.remove('hidden');
        isMenuVisible = true; // Menu is now visible
      });

      megaMenu.addEventListener('mouseover', function() {
        isMenuVisible = true; // Keep the menu visible even when hovering over it
      });

      menuTrigger.addEventListener('mouseout', function() {
        isMenuVisible = false; // Mouse left the menu trigger
        setTimeout(function() {
          if (!isMenuVisible) {
            megaMenu.classList.add('hidden');
          }
        }, 500); // Add a delay to allow moving mouse to the menu
      });

      megaMenu.addEventListener('mouseout', function() {
        isMenuVisible = false; // Mouse left the mega menu
        setTimeout(function() {
          if (!isMenuVisible) {
            megaMenu.classList.add('hidden');
          }
        }, 500); // Add a delay before hiding the menu
      });      
    }
  });
}

function mobileMenu() {
  // Get the toggle-dropdown element
  const toggleNav = document.querySelector('.toggle-nav');

  if (toggleNav) {
    // Get the dropdown element
    const nav = document.querySelector('.nav');
    
    // Add a click event listener to toggle the dropdown
    toggleNav.addEventListener('click', () => {
      nav.classList.toggle('hidden');
    });
  }
}
